import React from 'react'
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import { MuiInput } from "../../components/basicComponent/MuiInput";

const OutStandingReport = () => {
  return (
    <div className="grow">
    <SideMenu />
    <div className="wrapper flex grow flex-col">
      <Header />
      <main className="grow content" id="content" role="content">
        <div className="container-fixed">
          <div className="card-header text-center">
            <h3 className="card-title">OutStanding Report</h3>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card card-custom">
                <div className="card-body">
                  <div className="row mt-4">
                  <div className="col-md-4">
                      <MuiInput
                        label={"Date Wise"}
                        placeholder="Date Wise"
                      />
                    </div>
                    <div className="col-md-4">
                      <MuiInput
                        label={"Customer Name"}
                        placeholder="Customer Name"
                      />
                    </div>
                    <div className="col-md-4">
                      <MuiDatePicker
                        label="From Date"
                        value={null}
                        onChange={function (date: string): void {
                          throw new Error("Function not implemented.");
                        }}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiDatePicker
                        label="To Date"
                        value={null}
                        onChange={function (date: string): void {
                          throw new Error("Function not implemented.");
                        }}
                      />
                    </div>
              
                    

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                        <MuiButton
                          className="clear-btn "
                          label="Clear"
                          type="submit"
                        />
                        <MuiButton
                          label={"Get"}
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
  )
}

export default OutStandingReport
